<!--
  File name: SetDeadlineCard.vue
  Program Description:
    - This component allows the user to set deadline during show cause order.
-->
<template>
  <v-dialog
    v-model="openCard"
    max-width="700px"
  >
    <v-card class="pa-8">
      <v-container>
        <v-row class="py-5">
          <h2 class="primary--text">
            Resume Document Sharing
          </h2>
        </v-row>
        <v-row>
          <h4>No. of Days required for Document Submission</h4>
        </v-row>
        <v-row class="mt-7">
          <v-col>
            <v-row class="mr-1">
              <DateComponent
                id="extensionStart"
                :value="currentDate"
                :no-title="false"
                date-class="required-field"
                label="New Start Date"
                hide-details
                dense
                whole-month
                disabled
                outlined
              />
            </v-row>
            <v-row>
              <p
                :style="{
                  fontSize: '14px',
                  fontStyle: 'italic',
                  color: 'rgb(0,0,0,0.5)'
                }"
              >
                Initial Start Date: {{ extensionStart }}
              </p>
            </v-row>
          </v-col>
          <v-col>
            <v-row class="mr-1">
              <DateComponent
                id="extensionEnd"
                :value="end"
                :no-title="false"
                date-class="required-field"
                label="End Date"
                hide-details
                dense
                whole-month
                disabled
                outlined
              />
            </v-row>
          </v-col>
          <v-col cols="2">
            <v-row>
              <v-text-field
                id="daysForDocumentSubmission"
                v-model="days"
                class="required-field"
                label="Days"
                type="number"
                min="1"
                dense
                outlined
                :error-messages="genericError('days','Days')"
                @input="calculateDeadline"
              />
            </v-row>
          </v-col>
        </v-row>
        <v-row
          justify="end"
          class="pr-5 pt-5"
        >
          <v-col cols="2">
            <v-btn
              width="100px"
              text
              @click="closeModal"
            >
              CANCEL
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
              width="100px"
              color="primary"
              @click="updateDeadline"
            >
              SAVE
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { addDaysToDate, toDateString } from '@/utils/helpers'
import pdbnf from '@/utils/webapi/pdbnf'
import { validationMixin, custom, validationErrors } from '@/utils/validations'
export default {
  mixins: [
    validationMixin
  ],
  props: {
    formItem: {
      type: Object,
      default: undefined
    }
  },
  data: () => ({
    openCard: false,
    end: '',
    days: ''
  }),
  validations () {
    return custom.setDeadline
  },
  computed: {
    ...validationErrors,
    currentDate () {
      const currentDate = new Date()
      return currentDate.toISOString()
    },
    extensionStart () {
      const date = this.formItem.extensionStart
      return toDateString(date)
    },
    extensionEnd () {
      return this.formItem.extensionEnd
    },
    formId () {
      return this.formItem._id
    },
    isInvalid () {
      this.$v.days.$touch()
      return this.$v.days.$invalid
    }
  },
  methods: {
    // Calculates end date depending on the no. of days
    calculateDeadline (days) {
      if (this.isInvalid) {
        this.end = ''
        return
      }
      const deadline = addDaysToDate(this.currentDate, parseInt(days))
      this.end = deadline
    },
    openModal () {
      this.$v.days.$reset()
      this.openCard = true
    },
    closeModal () {
      this.openCard = false
      this.days = null
      this.end = ''
    },
    // set deadline
    async updateDeadline () {
      this.$v.$touch()
      if (this.isInvalid) return
      const daysForDocumentSubmission = this.days
      const resp = await pdbnf.setDeadline(this.formId, { daysForDocumentSubmission })
      const data = await resp.json()
      let message = 'You have successfully updated the deadline for Document Submission.'
      if (!resp.ok) message = data.error || data.message
      const type = resp.ok ? 'success' : 'error'
      this.closeModal()
      this.$store.dispatch('showAlert', {
        message,
        type
      })
      this.$emit('refresh')
    }
  }
}
</script>
